import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './i18n';
import Header from './components/Header';
import Hero from './components/Hero';
import SendSteps from './components/SendSteps';
import GlobalReach from './components/GlobalReach';
import CommonQuestions from './components/CommonQuestions';
import Download from './components/Download';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import NotFound from './components/NotFound';
import { homeHashAction, isHomeSectionId } from './navigation/goToSection';
import { PAGE_TITLES } from './navigation/pageTitle';
import { setCanonical } from './navigation/canonical';

function Home() {
  const location = useLocation();

  useEffect(() => {
    document.title = PAGE_TITLES.home;
    setCanonical('/');
    if (homeHashAction(location.hash) === 'section') {
      const id = decodeURIComponent(location.hash.slice(1));
      if (isHomeSectionId(id)) {
        document.getElementById(id)?.scrollIntoView({ behavior: 'auto', block: 'start' });
      }
      return;
    }
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [location.hash]);

  return (
    <div className="App min-h-screen relative">
      <Header />
      <main className="relative">
        <Hero />
        <SendSteps />
        <GlobalReach />
        <CommonQuestions />
        <Download />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
